module.exports = __webpack_public_path__ + "img/about-m-slide-18.2f3a7aae.jpg";